export function LegalPage({ C, onBack, title, updated, children }) {
  return (
    <div style={{ minHeight: "100vh", background: C.bg, color: C.text, fontFamily: "'DM Sans', system-ui, sans-serif" }}>
      <div style={{ maxWidth: 720, margin: "0 auto", padding: "40px 20px 80px" }}>
        <button onClick={onBack} style={{
          background: "transparent", border: `1px solid ${C.border}`, color: C.muted,
          borderRadius: 10, padding: "8px 14px", fontSize: 13, fontWeight: 600,
          cursor: "pointer", fontFamily: "inherit", marginBottom: 24,
          display: "inline-flex", alignItems: "center", gap: 6,
        }}>← Volver</button>

        <h1 style={{ color: C.text, fontWeight: 900, fontSize: 26, letterSpacing: "-0.02em", margin: "0 0 6px" }}>
          {title}
        </h1>
        {updated && <div style={{ color: C.muted, fontSize: 12.5, marginBottom: 28 }}>Última actualización: {updated}</div>}

        {children}
      </div>
    </div>
  );
}

export function Section({ C, title, children }) {
  return (
    <div style={{ marginBottom: 26 }}>
      <h2 style={{ color: C.text, fontWeight: 800, fontSize: 15.5, marginBottom: 8 }}>{title}</h2>
      <div style={{ color: C.muted, fontSize: 13.5, lineHeight: 1.7 }}>{children}</div>
    </div>
  );
}

export function ul(C) {
  return { margin: "10px 0 0", paddingLeft: 20, lineHeight: 1.7 };
}